import React from 'react';
import { DCBUserDetails as DCBUserDetailsScreen } from '@features/dcb-user-details';

export const DCBUserDetails = (props: any) => <DCBUserDetailsScreen {...props} />;
